var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlur2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1615,
    height: 719,
    viewBox: "0 0 1615 719",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_972_1162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 195,
    r: 22,
    fill: "#F0B518"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_972_1162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 707.5,
    cy: 458.5,
    r: 24.5,
    fill: "#6956E5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_972_1162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1493,
    cy: 456,
    r: 22,
    fill: "#F0B518"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_972_1162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1286.5,
    cy: 122.5,
    r: 22.5,
    fill: "#6956E5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_972_1162)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 118.5,
    cy: 600.5,
    r: 18.5,
    fill: "#6956E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_972_1162",
    x: 137,
    y: 73,
    width: 244,
    height: 244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_972_1162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_972_1162",
    x: 583,
    y: 334,
    width: 249,
    height: 249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_972_1162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_972_1162",
    x: 1371,
    y: 334,
    width: 244,
    height: 244,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_972_1162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_972_1162",
    x: 1164,
    y: 0,
    width: 245,
    height: 245,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_972_1162"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_972_1162",
    x: 0,
    y: 482,
    width: 237,
    height: 237,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_972_1162"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlur2);
export default __webpack_public_path__ + "static/media/blur2.eac5d6f6345b1fcf1b0843bfc00c93f9.svg";
export { ForwardRef as ReactComponent };